import { create } from "zustand";
import { ToolsStore } from "./types";
import { fetchAppInfo, fetchHealthcheck, fetchGraphs, fetchChunks, fetchChats } from "../../../api";
import { asyncActionWrapper } from "../utils/asyncActionWrapper";


export const useToolsStore = create<ToolsStore>((set) => ({
    loadingInfo: false,
    loadingGeneral: false,
    info: { app_version: "", database_migration: "" },
    healthCheck: { database: "", blob: "", document_intelligence: "", openai: "", speech_2_text: "" },
    graphs: { daily_stats: [], total_unique_users: 0, total_average_rating: 0, log_analytics: { client_types: [], generate_speech_total: 0, recognize_speech_total: 0 } },
    chunks: [],
    asyncActionWrapper,
    fetchGraphs: async () => {
        set({ loadingGeneral: true });
        set({ graphs: await fetchGraphs() });
        set({ loadingGeneral: false });
    },
    fetchInfo: async () => {
        set({ loadingInfo: true });
        set({ info: await fetchAppInfo() });
        set({ loadingInfo: false });
    },
    fetchHealthCheck: async () => {
        set({ loadingGeneral: true });
        set({ healthCheck: await fetchHealthcheck() });
        set({ loadingGeneral: false });
    },
    resetChunks: () => set({ chunks: [] }),
}));
